export default {
  operator: 'Operador',
  user: 'Usuário',
  value: 'Valor',
  date: 'Data',
  operators: 'Operadores',
  status: 'Status',
  users: 'Usuários',
  export: 'Exportar como XLSX',
  infoLabel: 'Informações do Componente',
  filterLabel: 'Aplicar filtro',
  trashLabel: 'Limpar filtro',
  closeLabel: 'Fechar informações',
  statusLabel: 'Status',
  openOperatorLabel: 'Abrir conversas do operador',
  viewChat: 'Visualizar conversas',
  faq: [
    {
      title: 'O que é ?',
      description: 'Tabela de status de operadores no Smart Care para acompanhamento de atividade.',
    },
    {
      title: 'Como alterar o Operador?',
      description: 'Para mudar o filtro deve-se clicar no campo “Operadores“, selecionar os Operadores desejados e clicar no ícone de "filtro" na parte superior direita da tabela, em seguida será exibido apenas as anotações dos operadores selecionados.',
    },
    {
      title: 'Como filtrar por status do operador?',
      description: 'Para filtrar por status, deve-se clicar no campo "Status do operador", selecionar se deseja filtrar apenas os operadores "ONLINE" ou "OFFLINE",',
    },
    {
      title: 'Como redefinir o filtro?',
      description: 'Para redefinir o filtro é necessário clicar no ícone de "lixeira", abaixo do ícone de "filtro", assim todos os filtros da tabela serão redefinidos ao padrão',
    },
  ],
  username: 'Nome do usuário',
  lastStatus: 'Última atualização',
  offlineText: 'Ausente',
  onlineText: 'Ativo',
};
